export default __webpack_public_path__ + "static/image-data-storage-component-b489bca447020ab2a0d01215403d662a.png";